import { Box, Grid, TextField, Button, Checkbox, FormControlLabel, Typography } from '@mui/material'
import { Wrapper } from '../../layouts/Wrapper'
import { FormEvent, useState } from 'react'
import { useAppDispatch } from '../../redux/hooks'
import { AppAlert } from '../../components/AppAlerts/AppAlerts'
import { addAlertWithTimeout } from '../../redux/features/alerts/alertsHelpers'
import { getAuthService } from '../../services/authService'
import { RecaptchaService } from '../../services/recaptchaService'

export const ResetPassword = () => {

  const dispatch = useAppDispatch()
  const [password, setPassword] = useState<string>('')
  const [passwordError, setPasswordError] = useState<string>('')
  const [processing, setProcessing] = useState<boolean>(false)
  const [rememberMe, setRememberMe] = useState<boolean>(false)

  const url = new URL(window.location.href)
  const searchParams = url.searchParams
  const token = searchParams.get('token')

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    resetPassword()
  }

  const handleSubmitClick = () => {
    resetPassword()
  }

  const resetPassword = async () => {
    if (validatePassword() || !password || processing) {
      return
    }
    setProcessing(true)
    try {
      const authService = await getAuthService()
      const recaptchaService = new RecaptchaService()
      const recaptchaToken = await recaptchaService.getToken()
        .catch(() => '')
      await authService.resetPassword(password, token ?? '', rememberMe, recaptchaToken)
        .then(() => {
          console.log('Account confirmed!')
        })
    } catch (err) {
      // const error = err as ResponseError
      // const res = error.response
      // const text = await res.text().catch(() => null)
      const alert = new AppAlert('error', 'Something went wrong, try again later')
      addAlertWithTimeout(dispatch, alert)
      console.error('Error resetting password:', err)
    }
    setProcessing(false)
  }

  const handlePasswordFocus = () => {
    setPasswordError('')
  }

  const handlePasswordBlur = () => {
    setPasswordError(validatePassword())
  }

  const validatePassword = () => {
    if (password.length < 8) {
      return 'Password must be at least 8 characters long'
    }
    if (!(/[A-Z]/.test(password))) {
      return 'Password must contain an uppercase letter'
    }
    if (!(/[a-z]/.test(password))) {
      return 'Password must contain a lowercase letter'
    }
    if (!(/[0-9]/.test(password))) {
      return 'Password must contain a number'
    }
    if (!(/(\^|\$|\*|\.|\[|\]|\{|\}|\(|\)|\?|-|"|!|@|#|%|&|\/|\\|,|>|<|'|:|;|\||_|~|`|\+|=)/.test(password))) {
      return 'Password must contain a special character'
    }
    return ''
  }

  return (
    <Wrapper>
      <Box component='form' onSubmit={handleSubmit} sx={{ mt: 3 }}>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12 }}>
            <TextField
              required
              fullWidth
              value={password}
              error={!!passwordError}
              helperText={passwordError}
              onFocus={handlePasswordFocus}
              onBlur={handlePasswordBlur}
              onChange={(e) => setPassword(e.target.value)}
              type='password'
              label='Password'
            />
          </Grid>
        </Grid>
        <Grid container sx={{ mt: 1, display: 'flex', justifyContent: 'end' }}>
          <FormControlLabel control={<Checkbox value={rememberMe} onChange={e => setRememberMe(e.target.checked)} />} label='Remember me' />
        </Grid>
        <Button disabled={processing || !password || !!passwordError} type='submit' fullWidth variant="contained" color="primary" sx={{ mt: 2, mb: 2 }} onClick={handleSubmitClick}>Reset Password</Button>
        <Box sx={{ textAlign: 'center', my: 1, mb: 0 }}>
          <Typography variant='caption'>
            This site is protected by reCAPTCHA and the Google&nbsp;
            <a href="https://policies.google.com/privacy">Privacy Policy</a> and&nbsp;
            <a href="https://policies.google.com/terms">Terms of Service</a> apply.
          </Typography>
        </Box>
      </Box>
    </Wrapper>
  )
}